import { BarsOutlined, CaretDownFilled } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Col, Drawer, Dropdown, Image, Layout, Menu, Row, Space } from 'antd';
import { FC, useCallback, useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { IndustryEntity } from '../../module/industry/entity/industry.entity';
import { getIndustryList } from '../../module/industry/service/industry.service';
import { NewsTypeEntity } from '../../module/news/entity/news.type.entity';
import newsTypeService from '../../module/news/service/news.type.service';
import { TypeEntity } from '../../module/product/entity/type.entity';
import { getTypeList } from '../../module/product/service/type.service';
import { SuccessStoryEntity } from '../../module/successStory/entity/success.story.entity';
import successStoryService from '../../module/successStory/service/success.story.service';
import { IconFont } from '../config/IconFont';

const { Content } = Layout;

export const BasicLayout: FC = () => {
	const [typeList, setTypeList] = useState<TypeEntity[]>([]);
	const [industryList, setIndustryList] = useState<IndustryEntity[]>([]);
	const [newsTypeArr, setnewsTypeArr] = useState<NewsTypeEntity[]>([]);
	const [successStoryArr, setSuccessStoryArr] = useState<SuccessStoryEntity[]>([]);
	const [menuVisible, setMenuVisible] = useState<boolean>(false);

	const navigate = useNavigate();

	const init = useCallback(async () => {
		// 获取type list
		const { data } = await getTypeList();
		setTypeList(data);
		// Get Industry List
		const industryArr = await getIndustryList();
		setIndustryList(industryArr.data);
		setTypeList(data);
		// Get News Type List
		const newsTypeRes = await newsTypeService.list();
		setnewsTypeArr(newsTypeRes.data);
		// Get Success Story List
		const successStoryRes = await successStoryService.list();
		setSuccessStoryArr(successStoryRes.data);
	}, []);

	useEffect(() => {
		init();
	}, [init]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const processTypeMenuArr = () => {
		return (
			<>
				{typeList.map((item: TypeEntity) => {
					return (
						<Menu.Item key={`type${item.id}`}>
							<span onClick={() => navigateTo(`/type/${item.id}`)}>{item.title}</span>
						</Menu.Item>
					);
				})}
			</>
		);
	};

	const processIndustryMenuArr = () => {
		return (
			<>
				{industryList.map((item: IndustryEntity) => {
					return (
						<Menu.Item key={`industry${item.id}`}>
							<span onClick={() => navigateTo(`/industry/${item.id}`)}>{item.title}</span>
						</Menu.Item>
					);
				})}
			</>
		);
	};

	const processNewsTypeMenuArr = () => {
		return (
			<>
				{newsTypeArr &&
					newsTypeArr.map((item: NewsTypeEntity) => {
						return (
							<Menu.Item key={`newsType${item.id}`}>
								<span onClick={() => navigateTo(`/news-type/${item.id}`)}>{item.title}</span>
							</Menu.Item>
						);
					})}
			</>
		);
	};

	const processSuccessStoryMenuArr = () => {
		return (
			<>
				{successStoryArr &&
					successStoryArr.map((item: SuccessStoryEntity) => {
						return (
							<Menu.Item key={`successStory${item.id}`}>
								<span onClick={() => navigateTo(`/success-story/${item.id}`)}>{item.title}</span>
							</Menu.Item>
						);
					})}
			</>
		);
	};

	const menuFunc = () => {
		return (
			<>
				<Menu.Item key='about1' onClick={() => navigateTo('/company')}>
					欧皮特介绍
				</Menu.Item>
				<Menu.Item key='about2' onClick={() => navigateTo('/history')}>
					欧皮特里程碑
				</Menu.Item>
			</>
		);
	};

	const navigateTo = (url: string) => {
		navigate(url);
		setMenuVisible(false);
	};

	const languageArr = (
		<Menu>
			<Menu.Item>
				<a target='_blank' style={{ textDecoration: 'none', display: 'flex' }} rel='noopener noreferrer' href='https://www.optibelt.com/en'>
					<IconFont type='icon-country-yingguo1' style={{ paddingTop: '.22rem' }} />
					English
				</a>
			</Menu.Item>
			<Menu.Item>
				<a target='_blank' style={{ textDecoration: 'none', display: 'flex' }} rel='noopener noreferrer' href='https://www.optibelt.com/de/branchen/'>
					<IconFont type='icon-country-deguo' style={{ paddingTop: '.22rem' }} />
					Deutsch
				</a>
			</Menu.Item>
			<Menu.Item>
				<a target='_blank' style={{ textDecoration: 'none', display: 'flex' }} rel='noopener noreferrer' href='https://www.optibelt.com/it/settori/'>
					<IconFont type='icon-country-yidali' style={{ paddingTop: '.22rem' }} />
					Italienisch
				</a>
			</Menu.Item>
			<Menu.Item>
				<a target='_blank' style={{ textDecoration: 'none', display: 'flex' }} rel='noopener noreferrer' href='https://www.optibelt.com/fr/secteurs/'>
					<IconFont type='icon-country-faguo' style={{ marginTop: '.22rem' }} />
					Französisch
				</a>
			</Menu.Item>
			<Menu.Item>
				<a target='_blank' style={{ textDecoration: 'none', display: 'flex' }} rel='noopener noreferrer' href='https://www.optibelt.com/sp/sectores/'>
					<IconFont type='icon-country-aodaliya-copy' style={{ marginTop: '.22rem' }} />
					Spanisch
				</a>
			</Menu.Item>
			<Menu.Item>
				<a target='_blank' style={{ textDecoration: 'none', display: 'flex' }} rel='noopener noreferrer' href='https://www.optibelt.com/pl/branze/'>
					<IconFont type='icon-country-bolan' style={{ marginTop: '.22rem' }} />
					Polnisch
				</a>
			</Menu.Item>
			<Menu.Item>
				<a target='_blank' style={{ textDecoration: 'none', display: 'flex' }} rel='noopener noreferrer' href='https://www.optibelt.com/ru/otrasli/'>
					<IconFont type='icon-country-eluosi' style={{ marginTop: '.22rem' }} />
					Russisch
				</a>
			</Menu.Item>
			<Menu.Item>
				<a target='_blank' style={{ textDecoration: 'none', display: 'flex' }} rel='noopener noreferrer' href='https://www.optibelt.com/tr/sektoerler/'>
					<IconFont type='icon-country-tuerqi' style={{ marginTop: '.22rem' }} />
					Türkisch
				</a>
			</Menu.Item>
			<Menu.Item>
				<a target='_blank' style={{ textDecoration: 'none', display: 'flex' }} rel='noopener noreferrer' href='https://www.optibelt.com/pt/setores/'>
					<IconFont type='icon-country-putaoya' style={{ marginTop: '.22rem' }} />
					Portugiesisch
				</a>
			</Menu.Item>
			<Menu.Item>
				<a target='_blank' style={{ textDecoration: 'none', display: 'flex' }} rel='noopener noreferrer' href='https://www.optibelt.com/us/'>
					<IconFont type='icon-country-meiguo' style={{ marginTop: '.22rem' }} />
					English (US)
				</a>
			</Menu.Item>
		</Menu>
	);

	return (
		<Container>
			<div className='head'>
				<div className='top'>
					<div className='innerContent'>
						<Space>
							<a href='/' className='nav-link' target=''>
								欧皮特首页
							</a>
							<a href='/' className='nav-link'>
								联系我们
							</a>
							<div>
								<Dropdown overlay={languageArr}>
									<span className='ant-dropdown-link'>
										<IconFont type='icon-country-earth1' />
										切换语言
									</span>
								</Dropdown>
							</div>
							<div onClick={() => navigate(`/registration`)} style={{ cursor: 'pointer' }}>
								CAP注册
							</div>
						</Space>
					</div>
				</div>
				<div className='bottom innerContent'>
					<div className='pc left'>
						<Space>
							<Dropdown overlay={<Menu>{processIndustryMenuArr()}</Menu>}>
								<span className='ant-dropdown-link' onClick={() => navigate('/industries')}>
									工业相关&nbsp;
									<CaretDownFilled />
								</span>
							</Dropdown>
							&nbsp; &nbsp;
							<Dropdown overlay={<Menu>{processTypeMenuArr()}</Menu>}>
								<span className='ant-dropdown-link' onClick={() => navigate('/products')}>
									<span>产品介绍&nbsp;</span>
									<CaretDownFilled />
								</span>
							</Dropdown>
							&nbsp; &nbsp;
							<Dropdown overlay={<Menu>{processNewsTypeMenuArr()}</Menu>}>
								<span className='ant-dropdown-link' onClick={() => navigate('/newsroom')}>
									新闻中心&nbsp;
									<CaretDownFilled />
								</span>
							</Dropdown>
							&nbsp; &nbsp;
							<Dropdown overlay={<Menu>{processSuccessStoryMenuArr()}</Menu>}>
								<span className='ant-dropdown-link' onClick={(e) => e.preventDefault()}>
									成功案例&nbsp;
									<CaretDownFilled />
								</span>
							</Dropdown>
							&nbsp; &nbsp;
							<Dropdown overlay={<Menu>{menuFunc()}</Menu>}>
								<span className='ant-dropdown-link' onClick={(e) => e.preventDefault()}>
									关于我们&nbsp;
									<CaretDownFilled />
								</span>
							</Dropdown>
							&nbsp; &nbsp;
							<span className='ant-dropdown-link' onClick={() => navigate('/distributor')}>
								真伪查询
							</span>
						</Space>
					</div>
					<div className='mobile left'>
						<BarsOutlined className='menu' onClick={() => setMenuVisible(true)} style={{ fontSize: '3rem' }} />
					</div>
					<div className='right'>
						<Image preview={false} src={'https://splashtest.oss-cn-shanghai.aliyuncs.com/img1/Logo-Optibelt-RGB.png'} />
					</div>
				</div>
			</div>
			<Content className='site-layout-background'>
				<Outlet />
			</Content>
			<footer>
				<div className='footer-section'>
					<div className='innerContent'>
						<h4>关注我们或下载我们的APP</h4>
						<Row className='followUs'>
							<Col xs={8} md={8} lg={4}>
								<a href='http://www.facebook.com/optibelt' target='_blank' rel='noreferrer'>
									<Space>
										<Image src='https://splashtest.oss-cn-shanghai.aliyuncs.com/img1/Facebook_32px.gif' preview={false} />
										Facebook
									</Space>
								</a>
							</Col>
							<Col xs={8} md={8} lg={4}>
								<a href='https://de.wikipedia.org/wiki/Optibelt' target='_blank' rel='noreferrer'>
									<Space>
										<Image src='https://splashtest.oss-cn-shanghai.aliyuncs.com/img1/wikipedia.png' preview={false} />
										Wikipedia
									</Space>
								</a>
							</Col>
							<Col xs={8} md={8} lg={4}>
								<a href='https://www.linkedin.com/company/optibelt-uk-limited/' target='_blank' rel='noreferrer'>
									<Space>
										<Image src='https://splashtest.oss-cn-shanghai.aliyuncs.com/img1/LinkedIn_32px.gif' preview={false} />
										LinkedIn
									</Space>
								</a>
							</Col>
							<Col xs={8} md={8} lg={4}>
								<a href='https://www.youtube.com/user/optibeltEN' target='_blank' rel='noreferrer'>
									<Space>
										<Image src='https://splashtest.oss-cn-shanghai.aliyuncs.com/img1/YouTube.gif' preview={false} />
										YouTube
									</Space>
								</a>
							</Col>
							<Col xs={8} md={8} lg={4}>
								<a href='https://itunes.apple.com/us/app/ioptibelt/id537184782?l=de&ls=1&mt=8' target='_blank' rel='noreferrer'>
									<Image src='https://splashtest.oss-cn-shanghai.aliyuncs.com/img1/Download_on_the_App_Store_Badge_US-UK_blk_092917.png' preview={false} />
								</a>
							</Col>
							<Col xs={8} md={8} lg={4}>
								<a href='https://play.google.com/store/apps/details?id=de.appcellent.optibelt' target='_blank' rel='noreferrer'>
									<Image src='https://splashtest.oss-cn-shanghai.aliyuncs.com/img1/google-play-badge-gb.png' preview={false} />
								</a>
							</Col>
						</Row>
						<Row className='foot-menu'>
							<Col xs={24} md={8} lg={4}>
								<h4>工业相关</h4>
								{industryList &&
									industryList.map((item) => {
										return (
											<div key={item.id} className='click' onClick={() => navigate(`/industry/${item.id}`)}>
												{item.title}
											</div>
										);
									})}
							</Col>
							<Col xs={24} md={8} lg={4}>
								<h4>产品相关</h4>
								{typeList &&
									typeList.map((item) => {
										return (
											<div key={item.id} className='click' onClick={() => navigate(`/type/${item.id}`)}>
												{item.title}
											</div>
										);
									})}
							</Col>
							<Col xs={24} md={8} lg={4}>
								<h4>新闻中心</h4>
								{newsTypeArr &&
									newsTypeArr.map((item) => {
										return (
											<div key={item.id} className='click' onClick={() => navigate(`/news-type/${item.id}`)}>
												{item.title}
											</div>
										);
									})}
							</Col>
							<Col xs={24} md={8} lg={4}>
								<h4>成功案例</h4>
								{successStoryArr &&
									successStoryArr.map((item) => {
										return (
											<div key={item.id} className='click' onClick={() => navigate(`/success-story/${item.id}`)}>
												{item.title}
											</div>
										);
									})}
							</Col>
							<Col xs={24} md={8} lg={4}>
								<h4>关于我们</h4>
								<div className='click' onClick={() => navigate(`/company`)}>
									欧皮特介绍
								</div>
								<div className='click' onClick={() => navigate(`/history`)}>
									欧皮特里程碑
								</div>
							</Col>
							<Col xs={24} md={8} lg={4}>
								<h4>联系我们</h4>
								<div>地址: </div>
								<div>上海：上海市闵行区七莘路3599弄5号楼203室<br/>
								太仓：江苏省太仓市宁波东路161号</div>
								<div>电话: 021-57687465</div>
								<div>邮箱: sales.china[at]optibelt.com</div>
								<div>上海、浙江：</div>
								<div>乐经理 15000289317</div>
								<br />
								<div>江苏、安徽、湖北：</div>
								<div>魏经理 15000297817</div>
								<br />
								<div>北京、天津、河北、河南、山西、内蒙古、黑龙江、吉林、辽宁、新疆、宁夏、青海、陕西、甘肃：</div>
								<div>郝经理 13817276830</div>
								<br />
								<div>广东、广西、湖南、江西、福建、海南：</div>
								<div>何经理 13817235512</div>
								<br />
								<div>山东：</div>
								<div>刘经理 13916381706</div>
								<br />
								<div>四川、重庆、云南、贵州、西藏：</div>
								<div>代经理 13817275271</div>
								<br />
								<div>汽车售后：</div>
								<div>谈经理 15821137288</div>
								<br />
								<div>汽车配套：</div>
								<div>周经理 15921609881</div>
								<br />
							</Col>
						</Row>
						<div>
							<a href={'http://beian.miit.gov.cn/'} target={'_blank'} rel='noreferrer'>
								沪ICP备2023002359号-2
							</a>
						</div>
					</div>
				</div>
			</footer>
			<Drawer title='欧皮特' visible={menuVisible} onClose={() => setMenuVisible(false)} key='left' placement='left' closable={false} className='drawer'>
				<Menu mode='inline'>
					<Menu.SubMenu key='menu1' title='工业相关'>
						{processIndustryMenuArr()}
					</Menu.SubMenu>
					<Menu.SubMenu key='menu2' title='产品介绍'>
						{processTypeMenuArr()}
					</Menu.SubMenu>
					<Menu.SubMenu key='menu3' title='新闻中心'>
						{processNewsTypeMenuArr()}
					</Menu.SubMenu>
					<Menu.SubMenu key='menu4' title='成功案例'>
						{processSuccessStoryMenuArr()}
					</Menu.SubMenu>
					<Menu.SubMenu key='menu5' title='关于我们'>
						{menuFunc()}
					</Menu.SubMenu>
					<Menu.Item key='menu6' onClick={() => navigateTo('/distributor')}>
						真伪查询
					</Menu.Item>
				</Menu>
			</Drawer>
		</Container>
	);
};

const Container = styled.div`
	height: 100%;

	a {
		text-decoration: none;
	}

	.innerContent {
		width: 100%;
		max-width: 1230px;
		margin: 0 auto;
	}

	.head {
		background: #fff;
		width: 100%;
		margin-bottom: 16px;
		position: fixed;
		top: 0;
		z-index: 999;
		padding-bottom: 16px;
		box-shadow: 0 0 2em 0 rgba(0, 0, 0, 0.2);

		.top {
			width: 100%;
			background: #eee;

			div {
				display: flex;
				justify-content: left;
				font-size: 12px;
				color: #666;

				a {
					text-decoration-line: none;
					color: #666;
				}

				span {
					svg {
						margin-top: -6px;
						width: 1.1rem;
						height: 1.1rem;
					}
				}
			}
		}

		.bottom {
			display: flex;
			justify-content: space-between;
			margin-top: 16px;

			.left {
				max-width: 870px;
				margin: auto 0 0 0;
				display: flex;
				justify-content: space-between;
				font-size: 19px;
				cursor: pointer;

				.ant-dropdown-link {
					color: #004885;
					display: flex;
					justify-content: left;

					.anticon {
						margin-top: 5px;
					}
				}

				.ant-dropdown-link:hover {
					font-weight: bold;
				}
			}

			@media (max-width: 768px) {
				.pc {
					display: none;
				}
			}

			@media (min-width: 768px) {
				.mobile {
					display: none;
				}
			}
		}
	}

	.site-layout-background {
		padding-top: 124px;
		background: #f0f1f0;
	}

	.footer-section {
		box-shadow: 2px 7px 7px rgb(73 54 73 / 30%) inset;
		border-bottom: 7px solid rgb(0, 72, 133);
		margin-top: 0;
		padding: 2rem 1rem;

		h4 {
			font-size: 1.4rem;
			color: #484848;
			margin-bottom: 1rem;
		}

		.followUs {
			display: flex;
			justify-content: space-between;
			padding-bottom: 2rem;
			border-bottom: 1px dotted #8c8b8b;
			margin-bottom: 3rem;
		}

		.foot-menu {
			display: flex;
			justify-content: space-between;
			width: 100%;
			flex-wrap: wrap;

			div {
				display: flex;
				flex-direction: column;
			}

			.click {
				cursor: pointer;
				color: #004885;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				width: 90%;
			}

			.click:hover {
				color: #001216;
			}
		}
	}
`;
